<template>
  <div class="subscribe-wrap">
    <van-nav-bar @click-left="clickBack" title="修改" left-arrow> </van-nav-bar>

    <div class="form-wrap">
      <van-field name="uploader" label="识别头像" size="large" required center>
        <template #input>
          <van-uploader
            v-model="curFileList"
            :after-read="afterReadCur"
            :before-delete="beforeDelCur"
            :max-count="1"
            multiple
            capture="camera">
            <img
              src="@/assets/images/avatar.png"
              alt=""
              style="width: 2.75rem;
                height: 2.75rem;
                border-radius: 50%;
                object-fit: cover;"/>
          </van-uploader>
        </template>
      </van-field>
      <van-field
        v-model="singleQuery.initiatorName"
        label="姓名"
        placeholder="请输入姓名"
        size="large"
        required
      />
      <van-field
        v-model="singleQuery.visitorPhone"
        label="手机号"
        placeholder="请输入手机号码"
        size="large"
        required
      />
      <van-field
        v-model="singleQuery.acceptName"
        label="被访人"
        placeholder="请选择被访人"
        size="large"
        clickable
        required
        readonly
      />
      <van-field
        v-model="singleQuery.visitorBeginTime"
        label="拜访时间"
        placeholder="点击选择"
        clickable
        readonly
        required
        is-link
        @click="clickTime('starttime')"
        size="large"
      />
      <van-field
        v-model="singleQuery.visitorEndTime"
        label="离开时间"
        placeholder="点击选择"
        clickable
        readonly
        is-link
        required
        @click="clickTime('endtime')"
        size="large"
      />
      <van-field
        v-model="singleQuery.visitorIdCrde"
        label="身份证号码"
        placeholder="请输入身证号码"
        size="large"
        :required="senseIDStatus"
      />
      <van-field
        v-model="singleQuery.affiliatedUnit"
        label="所属单位"
        placeholder="请输入所属单位"
        size="large"/>

      <van-field
        v-model="singleQuery.carNumber"
        label="车牌号"
        placeholder="请输入车牌号"
        size="large"
      />
      <van-field name="radio" label="预约事由" size="large">
        <template #input>
          <van-radio-group
            v-model="singleQuery.visitorGoal"
            direction="horizontal"
            @change="changeRadioType"
          >
            <van-radio
              :name="item.dictLabel"
              v-for="item in work"
              style="margin-bottom: 0.5rem;"
              :key="item.dictLabel"
              >{{ item.dictLabel }}</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        type="textarea"
        placeholder="请输入备注"
        label="备注"
        v-model="singleQuery.remark"
        size="large"
      ></van-field>
    </div>
    <!-- 添加同行人员 -->
    <updatePersinList :id="id" type="update" />

    <div style="padding: 2rem 1rem;">
      <van-row :gutter="20">
        <van-col :span="12">
          <van-button round type="default" block @click="clickBack"
            >返回</van-button
          >
        </van-col>
        <van-col :span="12">
          <van-button round type="info" block @click="clickEditBtn"
            >确认修改</van-button
          >
        </van-col>
      </van-row>
    </div>

    <!-- 拜访开始时间 -->
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :currentDate="new Date()"
    />

    <!-- 拜访离开时间 -->
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :currentDate="getD"
    />

    <!-- 添加被访人 -->
    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" />
    <!-- 成功提示 -->
    <subSuccess ref="subsuccess" />
  </div>
</template>

<script>
import moment from 'moment'
import { compare, getDateYMD, timeFormart } from '@/utils'
import { upload } from '@/utils/upload'
import Interviewee from '@/components/subScribePopup/interviewee'
import SelectTime from '@/components/subScribePopup/selectTime'
import subSuccess from '@/components/subScribePopup/subsuccess'
import updatePersinList from '@/components/subScribePopup/updatePersinList'
import * as validate from '@/utils/validate'

export default {
  components: {
    Interviewee,
    SelectTime,
    subSuccess,
    updatePersinList,
  },
  computed: {
    getD() {
      return new Date(moment().add(1, 'hours'))
    },
    id() {
      return this.$route.query.id
    },
  },
  data() {
    return {
      singleQuery: {
        initiatorName: '',
        visitorGoal: '',
        type: 0, // 0手动预约 1主动邀约邀约
        visitorBeginTime: '',
        visitorEndTime: '',
        carNumber: '',
        affiliatedUnit: '',
        acceptName: '',
        acceptId: '', // 接受者id
        // personnelMessageString:'0',// 0手动预约 1主动邀约邀约
      },
      // addPersonFileList: [],
      curFileList: [],
      curType: '',
      radioType: '',
      work: [],
      senseIDStatus: null,
    }
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) {
      this.getSubDetail()
      this.getWork()
      this.getSysSchool()
    }
  },
  methods: {
    clickEditBtn() {
      if (this.validateForm()) {
        this.editVisitor()
      }
    },
    async getSysSchool() {
      const { data, code, msg } = await this.$https.getSysSchool({
        // dictType: 'school_function_param',
        schoolId: localStorage.getItem('schoolId'),
      })
      if (code !== 200) {
        // this.$toast('')
        return
      }
      this.senseIDStatus = data.some((item) => item.functionDictCode == 6)
    },
    async editVisitor() {
      const {
        visitorBeginTime,
        visitorEndTime,
        visitorPhone,
        photoImg,
        ...rest
      } = this.singleQuery
      const { code } = await this.$https.editVisitor({
        ...rest,
        id: this.$route.query.id,
        photoImg,
        // personnelMessageString: this.personList,
        visitorBeginTime: timeFormart(visitorBeginTime),
        visitorEndTime: timeFormart(visitorEndTime),
        auditId: this.singleQuery.acceptId,
        appointmentType: 0,
        initiatorId: this.$store.state.userId,
        // initiatorName: data.initiatorName,
        initiatorPhone: visitorPhone,
      })
      if (code !== 200) {
        this.$toast({
          type: 'fail',
          message: '修改预约失败，请重试！',
        })
        return false
      }
      this.$toast({
        type: 'success',
        message: '修改成功',
        forbidClick: true,
        onClose: () => {
          this.clickBack()
        },
      })
    },
    async getWork() {
      const { code, data } = await this.$https.getwork({
        dictType: 'visit_reason',
      })
      if (code !== 200) {
        this.$toast('获取预约事由失败')
        return
      }
      this.work = data
    },
    clickBack() {
      this.$router.go(-1)
    },
    clickTime(type) {
      this.$refs[type].showTimePopup = true
    },

    handleSelIntervieweeItem(item) {
      // 更新被访人id
      this.$set(this.singleQuery, 'acceptId', item.id)
      this.$set(this.singleQuery, 'acceptName', item.name)
      this.$refs.interviewee.showiIntervieweePopup = false
    },

    handleTimeStartConfirm(value) {
      this.$set(this.singleQuery, 'visitorBeginTime', value)
      this.$refs.starttime.showTimePopup = false
    },
    handleTimeEndConfirm(value) {
      this.$set(this.singleQuery, 'visitorEndTime', value)
      this.$refs.endtime.showTimePopup = false
    },

    async afterReadCur(file) {
      const imgUrl = await upload(file.file)
      this.singleQuery.photoImg = imgUrl
    },
    beforeDelCur(item, obj) {
      this.curFileList.splice(obj.index, 1)
      this.singleQuery.photoImg = ''
    },

    changeRadioType(name) {
      console.log(name)
      this.radioType = name
      this.singleQuery.visitorGoal = name
    },

    // clickPersonMinus(index) {
    //   this.personList.splice(index + 1, 1)
    // },
    clickSubmit() {
      if (!this.validateForm()) {
      }
      this.singleAppointment()
    },
    validateForm() {
      let errMsg = {
        initiatorName: '姓名为空',
        visitorPhone: '手机号为空',
        photoImg: '请上传识别头像',
        visitorBeginTime: '请选择开始时间',
        visitorEndTime: '请选择离开时间',
        acceptId: '请选择被访人',
      }
      // let obj = this.personList[0]
      let objOther = this.singleQuery
      if (!objOther.photoImg) {
        this.$toast(errMsg.photoImg)
        return false
      }
      if (!objOther.initiatorName) {
        this.$toast(errMsg.initiatorName)
        return false
      }
      if (!objOther.visitorPhone) {
        this.$toast(errMsg.visitorPhone)
        return false
      }
      if (!objOther.acceptId) {
        this.$toast(errMsg.acceptId)
        return false
      }
      if (!objOther.visitorBeginTime) {
        this.$toast(errMsg.visitorBeginTime)
        return false
      }
      if (!objOther.visitorEndTime) {
        this.$toast(errMsg.visitorEndTime)
        return false
      }
      if (this.senseIDStatus) {
        if (!objOther.visitorIdCrde) {
          this.$toast('身份证号为空')
          return false
        }
      }
      // 离开时间大于开始时间
      if (
        moment(objOther.visitorEndTime).valueOf() -
          moment(objOther.visitorBeginTime).valueOf() <=
        0
      ) {
        this.$toast('离开时间不能小于开始时间')
        return false
      }
      if (!validate.isPhone(objOther.visitorPhone)) {
        this.$toast('手机号有误')
        return false
      }
      if (objOther.visitorIdCrde) {
        if (!validate.isIdCard(objOther.visitorIdCrde)) {
          this.$toast('身份证号有误，请检查')
          return false
        }
      }
      if (objOther.carNumber) {
        if (!validate.isLicencePlate(objOther.carNumber)) {
          this.$toast('车牌号有误，请检查')
          return false
        }
      }
      return true
    },
    // // 详情
    async getSubDetail() {
      const { data, code } = await this.$https.getVisitorDetail({
        visitorId: this.id,
      })
      if (code !== 200) {
        this.$toast('获取详情失败')
        return false
      }
      this.singleQuery = data
      this.singleQuery.visitorBeginTime = getDateYMD(data.visitorBeginTime)
      this.singleQuery.visitorEndTime = getDateYMD(data.visitorEndTime)

      this.curFileList.push({
        url: data.photoImg,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .van-uploader__preview-image {
  border-radius: 50%;
}
.form-wrap {
  margin: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
}
</style>
